import en from '../../../lang/en-us';
import { isMobileDevice } from '../../../utils/constants';

const { } = en;

function PrivacyPolicy(props: any) {
    return (
        <div className="curved-bg terms-content">
            <h2 className="heading">
                <a onClick={() => props.history.goBack()}>
                    {isMobileDevice() && <img src="/images/left-arrow-black.svg" alt="icon" />}
                </a>
                Privacy Policy
            </h2>
            <div className="curved-bg-content">
                <p>
                    The QRTAs respects your privacy and has accordingly formulated a privacy policy,
                    in compliance with the applicable laws (the “Privacy Policy”). Privacy Policy of
                    this app/platform is associated with the Privacy Policy of the respective QRTAs,
                    and it confirms to the respective QRTAs commitment to privacy and demonstrates
                    the ways we ensure that data privacy is protected by offering you an effective,
                    safe and secure online experience in compliance with Information Technology
                    (Reasonable Security Practices and Procedure and Sensitive Personal Data or
                    Information) Rules, 2011 and The Aadhaar Act, 2016.
                </p>
                <p>
                    QRTAs Privacy Policy applies to the Sensitive Personal Data or Information
                    (“SPDI”) of all our Customers / Investors and Clients that is in our possession
                    and control. We request Investors / Clients / Customers to kindly read this
                    Policy on Privacy carefully.
                </p>
                <p>
                    QRTAs either directly or through third party service providers collects,
                    receives, possesses, stores, deals, or handles information received from
                    investors, client, customers whether existing or prospective in order to provide
                    RTA Services, and do not use such information for any other purpose except as
                    set out herein, or as otherwise required or permitted by applicable law.
                </p>
                <p>
                    The information can be personal and sensitive in nature as given below in the
                    indicative list:
                </p>
                <ol>
                    <li>
                        Bank Account details, change of bank account details or registration of
                        multiple bank accounts etc. through forms;
                    </li>
                    <li>
                        Payment instrument details at the time of submitting forms at the time of
                        investment or as proof for carrying out change of bank account or any other
                        details of debit card obtained (if any);
                    </li>
                    <li> Biometric information obtained, if any;</li>
                    <li> Demat account details like beneficiary account no. etc.</li>
                    <li> Annual Income and savings profile; and;</li>
                    <li> Other information as may be considered as sensitive and personal.</li>
                </ol>
                <p>
                    The aforesaid information is being collected by QRTAs or third-party service
                    providers to service you better and to be in complaint with Know Your Client
                    (“KYC”) norms under the Prevention of Money Laundering Act 2001, (“PMLA”), the
                    rules issued thereunder, and guidelines and circular on Anti-Money Laundering
                    issued by SEBI and allied SEBI related Regulations, as amended till date.
                </p>
                <p>
                    You hereby agree that you may be requested to provide your express consent by
                    clicking on the ‘I ACCEPT’ button at the time of submission of your Personal
                    Information on this application, to collect, process, store, share and purge the
                    information submitted by you, failing which you will be unable to avail the
                    Services offered on the application.
                </p>
                <p> This Privacy Policy covers the below mentioned topics:</p>
                <ol>
                    <li>How is Personal Information collected?</li>
                    <li>How is Personal Information used?</li>
                    <li>Sharing of Personal Information;</li>
                    <li>How access to Customer Information is limited to employees?</li>
                    <li>Information Security;</li>
                    <li>Data Retention {'&'} Erasure;</li>
                    <li>Incident Management.</li>
                </ol>
                <h3>How is Personal Information Collected ?</h3>
                <p>
                    The Personal Information that you share with us would be entitled to privacy and
                    kept strictly confidential. The Personal Information along with all supporting
                    documents submitted by you shall be used for the limited purpose: Personal
                    Information is collected online through our website and mobile app/platforms.We
                    gather information that you provide to us when you:
                </p>
                <ol>
                    <li>
                        Purchase products or services through AMCs / Brokers or directly approaching
                        QRTA’s Investor Service Centres (“ISCs”) to avail the services;
                    </li>
                    <li>
                        Make an inquiry, provide feedback, submit correspondence, or make a
                        complaint over the phone, by email, on our website or by post;
                    </li>
                    <li>Register for, and update an online account with us;</li>
                    <li>Enter into a separate Agreement/contract/understanding with us;</li>
                    <li>
                        Certain information and/or data may be automatically collected through the
                        use of ‘cookies’.
                    </li>
                </ol>
                <h3>How Personal information is Used ?</h3>
                <p>
                    QRTAs use information to comply with laws, guidelines and regulations that
                    govern the financial services in the country in order to detect, prevent illegal
                    activities, fight spam, and protect the rights and property of clients. QRTAs
                    may use the information shared by Clients regarding the products and services to
                    enhance the service-related improvements. Reports are generated to protect and
                    defend the rights, interests of Clients products and services.
                </p>
                <p>
                    We also monitor Internet Protocol (IP) addresses, browser supplied information
                    and site session information may be recorded as part of the normal operations
                    and for security monitoring purposes.
                </p>
                <p>
                    Some of our products and services collect information about system and product
                    data. We use this information to manage and administer our products and
                    services, to issue updates and new versions, testing and monitoring services
                    that we provide, enhancing our products and services, and improving and
                    targeting our communications with you.
                </p>
                <h3>Sharing of Personal Information:</h3>
                <p>
                    QRTAs shall reveal only such information to external authorities to comply with
                    applicable laws including cyber laws, based on relevance to comply with
                    applicable laws and to third party service providers such as distributors,
                    banks, sub-brokers, call centers, custodians, depositories to ensure smooth
                    functioning of the activities.
                </p>
                <h3>Access to customer information is limited to employees and Third Parties :</h3>
                <p>
                    QRTAs limits access to personally Identifiable Information (“PII”) to those
                    employees with a business reason for knowing such information about investors.
                    We regularly educate our employees on their responsibility to protect the
                    confidentiality of investors’ information. We ensure to enter into suitable
                    terms with third party service providers to protect client confidentiality and
                    accordingly execute Non-Disclosure Agreement (“NDA”) with them.
                </p>
                <p>
                    Every person who has or is provided with an access to such data, undergoes
                    periodical training with regards data handling, data protection and is also
                    informed about all the consequences in case of any violation privacy terms.
                </p>
                <h3>Information Security :</h3>
                <p>
                    To protect Personal Information from unauthorized access and use, QRTAs use
                    security measures and controls that comply with applicable laws and regulations
                    and is a certified ISO 27001 ISMS Company. These measures may include device
                    safeguards and secured files and buildings as well as oversight of their
                    third-party service providers to ensure information remains confidential and
                    secure.We have adopted all the suitable measures to diagnose any problems with
                    its server and to administer the application including by blocking certain
                    addresses that it feels are inappropriately using its application. In the event
                    of any breach or attempted breach by any third party, in compliance with the
                    applicable information technology laws, it will try to rectify the problems as
                    soon as possible.
                </p>
                <h3>Data Retention {'&'} Erasure :</h3>
                <p>
                    We ensure that we meet the ‘data minimization’ and ‘storage limitation’
                    principles and that personal information is stored, archived, and destroyed
                    compliantly and ethically. We have dedicated erasure procedures in place to meet
                    the new ‘Right to Erasure’ obligation and are aware of when this and other data
                    subject’s rights apply, along with any exemptions, response timeframes and
                    notification responsibilities. QRTAs may retain the data as may be provided by
                    the client till such time as may be provided under the law and as required to
                    efficiently provide service to the clients.
                </p>
                <p>
                    Any data destroyed shall be disposed of in a manner that protects the privacy of
                    the Personal Information received by us from the user in an appropriate manner
                    as per the industry standard practices and norms.
                </p>
                <h3>Incident Management :</h3>
                <p>
                    Our Incident Reporting procedures ensure that we have safeguards and controls in
                    place to identify, assess, investigate, and report any personal data breach at
                    the earliest possibility. Our procedures are robust and have been disseminated
                    to all employees, who are aware of the reporting lines and steps to follow.
                </p>
                <h3>Liability : </h3>
                <p>
                    QRTAs shall in no manner be liable for any violation of data, if the data,
                    <br />
                    a) is in public domain; or <br />
                    b) is a result of any illegal and unlawful misuse;
                </p>
                <h3>Public Data : </h3>
                <p>
                    Data that is available in public domain shall not be governed by this Policy.
                    QRTAs shall not be responsible in any manner of whatsoever nature for any
                    violation or misuse of such Public Data.
                </p>
                <h3>Changes to this Policy</h3>
                <p>
                    QRTAs reserves the right to change this Policy at any time by revising it. This
                    privacy policy is not intended to and does not create any contractual or other
                    legal rights in or on behalf of any party. By accessing QRTAs website, you
                    acknowledge and fully understand QRTAs Privacy Policy and freely consent to the
                    information collection and use practices described in this Policy. We encourage
                    you to periodically review this privacy policy to stay informed about how we are
                    helping to protect the personal information we collect. Your continued use of
                    the service constitutes your agreement to this privacy policy and any updates.
                </p>
                <h3>Link to other sites</h3>
                <p>
                    For your convenience, this page may contain certain hyperlinks to other
                    sites/Platform.. While we try to link only to sites/Platform that share our high
                    standards and respect for privacy, we are not responsible for the content or the
                    privacy practices employed by other sites/Platform. We recommend that you check
                    the policy of each site/Platform you visit and contact the owner or operator of
                    such website if you have any concerns or questions.
                </p>
                <h3>Consent</h3>
                <p>
                    By accessing this web site and any of its pages you are agreeing to the Privacy
                    Policy. Clients shall not be covered by this Policy, if they access other
                    websites using links from our website.
                </p>
                <h3>Grievance Redressal</h3>
                <p>
                    If Clients / Customer / Investors have any concerns relating to their personal
                    and sensitive information they may be addressed to{' '}
                    <a href="mailto:privacy@camsonline.com">privacy@camsonline.com</a> or{' '}
                    <a href="mailto:privacy@kfintech.com">privacy@kfintech.com</a> .
                </p>
            </div>
        </div>
    );
}
export default PrivacyPolicy;
